import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { AuthService } from "services/auth.service";
import logoCiel from "assets/img/Logo-ciel.jpg";

export default function Login() {
  const history = useHistory();
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await AuthService.login({
        username: credentials.username,
        password: credentials.password,
        rememberMe: true,
      });
      // Si on arrive ici, le token est dans le localStorage
      history.push("/admin/dashboard");
    } catch (error) {
      console.error("Erreur d'authentification", error);
      alert("Identifiants incorrects.");
    }
  };
  return (
    <>
      <div className="container mx-auto px-4 h-full">
        <div className="flex content-center items-center justify-center h-full">
          <div className="w-full lg:w-4/12 px-4">
            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-[#0F172A] border-0">
              {/* En-tête épuré */}
              <div className="text-white text-center mt-10 font-bold px-6">
                <div className="w-20 h-20 bg-white text-[#253a5c] rounded-full flex items-center justify-center mx-auto mb-4 shadow-xl border-4 border-slate-700">
                  <img
                    src={logoCiel}
                    alt="Logo Église"
                    className="w-12 h-12 object-contain"
                  />
                </div>
                <h3 className="text-2xl tracking-wide uppercase">Connexion</h3>
                <p className="text-slate-400 text-xs font-normal mt-2">
                  Gestion Église - Administration
                </p>
              </div>

              <div className="flex-auto px-4 lg:px-10 py-10">
                <form onSubmit={handleLogin}>
                  {/* Champ Identifiant - Sans Label */}
                  <div className="relative w-full mb-6">
                    <div className="relative flex w-full flex-wrap items-stretch">
                      <span className="z-10 h-full leading-snug font-normal absolute text-center text-slate-400 bg-transparent rounded text-base items-center justify-center w-10 pl-3 py-4">
                        <i className="fas fa-user"></i>
                      </span>
                      <input
                        name="username"
                        type="text"
                        className="border-0 px-3 py-4 pl-12 placeholder-slate-400 text-slate-600 bg-white rounded text-sm shadow focus:outline-none focus:ring-2 focus:ring-[#D4AF37] w-full ease-linear transition-all duration-150"
                        placeholder="Nom d'utilisateur ou Email"
                        required
                        value={credentials.username}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  {/* Champ Mot de passe - Sans Label */}
                  <div className="relative w-full mb-6">
                    <div className="relative flex w-full flex-wrap items-stretch">
                      <span className="z-10 h-full leading-snug font-normal absolute text-center text-slate-400 bg-transparent rounded text-base items-center justify-center w-10 pl-3 py-4">
                        <i className="fas fa-lock"></i>
                      </span>
                      <input
                        name="password"
                        type="password"
                        className="border-0 px-3 py-4 pl-12 placeholder-slate-400 text-slate-600 bg-white rounded text-sm shadow focus:outline-none focus:ring-2 focus:ring-[#D4AF37] w-full ease-linear transition-all duration-150"
                        placeholder="Mot de passe"
                        value={credentials.password}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  {/* Souvenir de moi & Options */}
                  <div className="flex items-center justify-between mb-6">
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        id="customCheckLogin"
                        type="checkbox"
                        className="form-checkbox border-0 rounded text-slate-700 w-5 h-5 ease-linear transition-all duration-150"
                      />
                      <span className="ml-2 text-xs font-semibold text-slate-300">
                        Se souvenir
                      </span>
                    </label>
                    {/* Remplacement du lien Oublié ? */}
                    <Link
                      to="/auth/reset-password/init"
                      className="text-slate-400 hover:text-white transition-all"
                    >
                      <small className="text-xs">Mot de passe oublié ?</small>
                    </Link>
                  </div>

                  {/* Bouton Connexion */}
                  <div className="text-center">
                    <button
                      className="bg-[#D4AF37] text-[#1e293b] active:bg-yellow-600 text-sm font-bold uppercase px-6 py-4 rounded shadow-lg hover:shadow-xl outline-none focus:outline-none w-full ease-linear transition-all duration-150 flex items-center justify-center"
                      type="submit"
                    >
                      <i className="fas fa-sign-in-alt mr-2"></i> Accéder au
                      portail
                    </button>
                  </div>

                  <div className="text-center mt-8 text-slate-400">
                    <small>
                      Pas encore de compte ?{" "}
                      <strong>Contactez l'administration</strong>
                    </small>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
